import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=28f93fcc&scoped=true"
import script from "./Send.vue?vue&type=script&lang=ts"
export * from "./Send.vue?vue&type=script&lang=ts"
import style0 from "./Send.vue?vue&type=style&index=0&id=28f93fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f93fcc",
  null
  
)

export default component.exports